const commonQuestions = [
  {
    question:
      "Who is the person to attend the Assessment Meeting for This Business. Include all Information",
    answer: "",
    placeholder:
      "The person to attend this meeting is Mr./Miss last name, first name. To reach them, call 1-123-123-1234. Their email is and the other information is...",
  },
  {
    question:
      "What are your primary business objectives for the next year? (e.g., revenue growth, market expansion, profitability improvement)",
    answer:
      "Our main goal for the next year is to achieve a 20% growth in revenue through effective market expansion strategies.",
    placeholder: "We aim to expand our market and increase revenue by X%.",
  },
  {
    question:
      "Are there any specific milestones or targets you want to achieve?",
    answer:
      "We're targeting to onboard 1000 new customers and launch a new product line by the end of the year.",
    placeholder:
      "We have set milestones to reach X number of customers and launch Y product by Z date.",
  },
  {
    question: "What are the key challenges you face as a Small Business?",
    answer: "",
    placeholder:
      "As a small business, we face challenges such as limited resources, competition, and building brand awareness.",
  },
  {
    question:
      "Do you have a business growth plan or expansion strategy in place?",
    answer: "",
    placeholder:
      "Yes, we have a growth plan that includes opening a new location and launching an online store to reach a wider audience.",
  },
  {
    question: "How do you currently channel sales for your business?",
    answer: "",
    placeholder:
      "We primarily channel sales through our e-commerce website and also partner with local retailers.",
  },
];

const smallBusinessQuestions = [
  ...commonQuestions,

  {
    question:
      "How do you currently market your products or services to your target audience?",
    answer: "",
    placeholder:
      "We use a combination of social media marketing, local advertising, and word-of-mouth referrals to reach our target audience.",
  },
  {
    question:
      "What strategies have you implemented to attract and retain customers?",
    answer: "",
    placeholder:
      "We offer loyalty programs, discounts for repeat customers, and personalized customer experiences to attract and retain our clientele.",
  },
  {
    question:
      "Are there any industry trends that you're currently capitalizing on?",
    answer: "",
    placeholder:
      "We're leveraging the growing trend of e-commerce and online sales to expand our market reach.",
  },
  {
    question:
      "How do you handle your business's financial management, including budgeting and expenses?",
    answer: "",
    placeholder:
      "We closely monitor our budget, track expenses, and use accounting software to ensure proper financial management.",
  },
  {
    question:
      "Do you have a business growth plan or expansion strategy in place?",
    answer: "",
    placeholder:
      "Yes, we have a growth plan that includes opening a new location and launching an online store to reach a wider audience.",
  },
  // ... (add more questions as needed)
  {
    question:
      "Is there anything else you'd like to share with us that you feel is important for the growth assessment?",
    answer: "",
    placeholder:
      "We value your insights. Please feel free to share any additional information that you think is relevant for our assessment.",
  },
];

export default smallBusinessQuestions;
